import React from "react";

import { Button, Card, Flex, SkeletonWrapper } from "components";

export type ListCardProps = {
  title?: string;
  titleButton?: {
    label: string;
    onClick: () => void;
  };
  dataPairs?: Array<{ label: string; value: string; children?: React.ReactNode }>;
  className?: string;
  dataTestId?: string;
  isOutlined?: boolean;
  isSublist?: boolean;
  isLoading?: boolean;
};

export const ListCard: React.FC<ListCardProps> = ({ title, titleButton, dataPairs, className = "", dataTestId = "", isOutlined, isSublist, isLoading }) => (
  <Card dataTestId={dataTestId} className={`list-card ${isOutlined ? "outlined" : ""} padding-150 ${className}`}>
    <Flex className={"padding-bottom-100"} align="center" justify="space-between">
      <SkeletonWrapper className="margin-0 skeleton-rectangular" width="50%" height="2rem" type="block" isLoading={isLoading}>
        {isSublist ? <h5>{title}</h5> : <h3>{title}</h3>}
        {titleButton && (
          <Button type="tertiary" className="title-button margin-0" onClick={titleButton.onClick}>
            {titleButton.label}
          </Button>
        )}
      </SkeletonWrapper>
    </Flex>
    {dataPairs?.map((record, index) => (
      <div key={index}>
        <Flex gap={64} justify="space-between">
          <SkeletonWrapper className="margin-0 skeleton-rectangular" width="100%" height="1.5rem" type="block" isLoading={isLoading}>
            <span>{record.label}</span>
          </SkeletonWrapper>
          <SkeletonWrapper className="margin-0 skeleton-rectangular" width="100%" height="1.5rem" type="block" isLoading={isLoading}>
            <span className="paragraph-m-bold">{record.value}</span>
          </SkeletonWrapper>
        </Flex>
        {(index + 1 !== dataPairs.length || record.children) && <hr />}
        {record.children}
      </div>
    ))}
  </Card>
);
